import React, {Component} from 'react';
import styles from "./evaluate.module.css";


import closeIcon from "../../img/bt-close.png";
import JichuZhang from "./honglingjin/jichuZhang/jichuZhang.jsx";
import TeseZhang from "./honglingjin/teseZhang/teseZhang.jsx";
import YixingZhang from "./honglingjin/yixingZhang/yixingZhang.jsx";
import LaodongJiaoyu from "./laodongjiaoyu/laodongJiaoyu.jsx";

const Evaluate = props => (
    <div className={styles["modal-overlay"]}>
        <div className={styles["modal-content"]}>
            <div className={styles.titlebar}>
                <div className={styles["text-name"]}>
                    评价 {props.student_name}
                </div>

                <img
                    className={styles.close}
                    src={closeIcon}
                    onClick={props.onRequestClose}
                />
            </div>

            <div className={styles["list-warpper"]}>
                {
                    props.xueyuanList.map((item,index) => {
                        return (
                            <div className={styles["list-item"]}>
                                <div className={props.xueyuan_code==item.xueyuan_code?styles["xueyuan-selected"]:styles["xueyuan-unselected"]}
                                onClick={props.clickXueyuan.bind(null,item.xueyuan_code,index)}>
                                    {item.xueyuan_name}
                                </div>
                                {props.xueyuan_code==item.xueyuan_code?
                                    <div className={styles.line}></div>
                                    :null}

                                </div>);
                    })
                }
            </div>

            <div className={styles["list-warpper-xueke"]}>
                {
                    props.xuekeList.map((item,index) => {
                        return (
                            <div className={styles["list-item-xueke"]}>
                                <div className={props.xueke_code==item.xueke_code?styles["xueke-selected"]:styles["xueke-unselected"]}
                                     onClick={props.clickXueke.bind(null,item.xueke_code,index)}>
                                    {item.xueke_name}
                                </div>
                            </div>);
                    })
                }
            </div>

            {props.xueke_code!=='26'&&props.xueke_code!=='27'?
                <div className={styles["list-warpper-liyou"]}>
                    {
                        props.liyouList.map((item) => {
                            return (

                                <div className={styles["item-liyou"]}
                                     onClick={props.clickLiyou.bind(null,item.dianzan_code)}>
                                    {item.liyou}
                                </div>
                            );
                        })
                    }
                </div> :null}

            {props.xueke_code=='26'?

            <div className={styles["list-warpper"]}>
                <div className={styles["list-item"]}>
                    <div className={props.honglingjinTab==0?styles["xueyuan-selected"]:styles["xueyuan-unselected"]}
                    onClick={props.clickHonglingjinTab.bind(null,0)}>
                        基础章
                    </div>
                    {props.honglingjinTab==0?
                        <div className={styles.line}></div>
                        :null}
                </div>
                <div className={styles["list-item"]}>
                    <div className={props.honglingjinTab==1?styles["xueyuan-selected"]:styles["xueyuan-unselected"]}
                         onClick={props.clickHonglingjinTab.bind(null,1)}>
                        特色章
                    </div>
                    {props.honglingjinTab==1?
                        <div className={styles.line}></div>
                        :null}
                </div>
                <div className={styles["list-item"]}>
                    <div className={props.honglingjinTab==2?styles["xueyuan-selected"]:styles["xueyuan-unselected"]}
                         onClick={props.clickHonglingjinTab.bind(null,2)}>
                        一星章
                    </div>
                    {props.honglingjinTab==2?
                        <div className={styles.line}></div>
                        :null}
                </div>
            </div>  :null}


            {props.xueke_code=='26'&&props.honglingjinTab==0?
                <JichuZhang
                    clickLiyou={props.clickLiyou}
                    jichuZhangList={props.jichuZhangList}
            />:null}

            {props.xueke_code=='26'&&props.honglingjinTab==1?
                <TeseZhang
                    clickLiyou={props.clickLiyou}
                    teseZhangList={props.teseZhangList}
                />:null}

            {props.xueke_code=='26'&&props.honglingjinTab==2?
                <YixingZhang
                    yixingData={props.yixingData}
                />:null}

            {props.xueke_code=='27'?
                <LaodongJiaoyu
                    laodongJiatingList={props.laodongJiatingList}
                    laodongXuexiaoList={props.laodongXuexiaoList}
                    laodongShehuiList={props.laodongShehuiList}
                    clickLiyou={props.clickLiyou}
                    xiaodangjiaList={props.xiaodangjiaList}
                    xiaogongjiangList={props.xiaogongjiangList}
                    xiaoboshiList={props.xiaoboshiList}
                    xiaohuojuList={props.xiaohuojuList}
                />:null}

        </div>
    </div>
)

export default Evaluate;
